import { toValue, type MaybeRefOrGetter } from "vue";
import { useFormats } from "~/composables/utils/useFormat";
import { useAuthStore } from "~/store/auth/auth.store";
import { TimezoneDisplayModeEnum } from "~/utils/enums/timezones.enums";
import { toReaderDateTime } from "~/utils/helpers/timezones";

/** A step's bounds as a screen shows them: in the signed-in user's zone in READER mode, as entered in STEP mode. */
export function useReaderDateTime(mode: MaybeRefOrGetter<TimezoneDisplayModeEnum>) {
  const authStore = useAuthStore();
  const { toDateDisplay } = useFormats();

  /** `null` in STEP mode, and for a step without hours, whose date is never converted. */
  function readerDateTime(
    date: string | Date | null | undefined,
    time: string | null | undefined,
    timezone: string | null | undefined,
  ): ReturnType<typeof toReaderDateTime> {
    return toValue(mode) === TimezoneDisplayModeEnum.READER
      ? toReaderDateTime(date, time, timezone, authStore.userTimezone)
      : null;
  }

  /** The day follows the converted hour, or the date would contradict it. */
  function displayDay(
    date: string | Date,
    time: string | null | undefined,
    timezone: string | null | undefined,
  ): string {
    return readerDateTime(date, time, timezone)?.date ?? toDateDisplay(date);
  }

  return { readerDateTime, displayDay };
}
